<template>
  <div
    class="ignite-markdown"
    v-html="parsedMarkdown"
  />
</template>

<script lang="ts">
import DOMPurify from 'dompurify'
import { marked } from 'marked'
import {
  Component,
  Vue,
} from 'vue-property-decorator'

@Component({})
export default class IgniteMarkdown extends Vue {
  parsedMarkdown = ''

  created(): void {
    this.setCompiledTemplate()
  }

  beforeUpdate(): void {
    this.setCompiledTemplate()
  }

  private async setCompiledTemplate() {
    if (this.$slots && this.$slots.default)
      this.parsedMarkdown = DOMPurify.sanitize(await marked.parse(this.$slots.default[0].text ?? ''), { ADD_ATTR: ['target', 'rel'] })
  }
}
</script>
